import React from "react";

import { MenuItem, Select, makeStyles } from "@material-ui/core";
import { RepeatFrequency } from "@hubcapp/types";

import { RepeatSelectProps } from "./types";

const useStyles = makeStyles(theme => ({
  repeatSelect: {
    color: theme.palette.text.secondary,
    paddingRight: theme.spacing(5),
  },
}));

const RepeatSelect: React.FC<RepeatSelectProps> = ({
  disabled,
  values,
  handleFocus = () => {},
  handleChange = () => {},
}) => {
  const classes = useStyles();

  return (
    <Select
      name="repeat"
      id="repeat"
      displayEmpty
      disabled={disabled}
      value={values?.repeat || ""}
      // @ts-ignore
      onChange={handleChange}
      classes={{ root: classes.repeatSelect }}
      disableUnderline
      onFocus={() => handleFocus(values?.repeat)}
    >
      <MenuItem value="">No repeat</MenuItem>
      {Object.keys(RepeatFrequency).map(key => (
        <MenuItem key={key} value={key}>
          {key}
        </MenuItem>
      ))}
    </Select>
  );
};

export default RepeatSelect;
